/*!
 * ModalAjaxLoader
 * “クリック → JSON取得 → html挿入 → Remodal表示”を共通化
 * 既定：B型（paramsMapping）。必要時のみ A型（urlBuilder）でURL生成を上書きできます。
 * 命名規則：trigger => .<modalId>_trigger / target => #<modalId>_content
 * Remodalのopenは内部固定（autoOpen:true / before）
 * 依存：jQuery / Remodal / fetch / AbortController
 */
(function (global, $) {
  'use strict';

  if (!$ || typeof $.fn.on !== 'function') {
    console.error('ModalAjaxLoader: jQueryが読み込まれていません。');
    return;
  }

  //=============================================================
  // 内部デフォルト（環境より低い優先度）
  //=============================================================
  var DEFAULTS = {
    timeout: 10000,
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
    credentials: 'same-origin',
    loadingHtml: '<div class="Cnt P30"><img src="/assets/images/icon/loadingOvalBlue.svg" width="80" height="80" alt="loading" /></div>',
    restoreOnError: true,
    eventNamespace: '.modalajaxloader',
    cache: 'off', // 'off' | 'memory'
    extractSelector: null, // 既定は init時に '#<modalId>_content' を自動設定
    extractMode: 'inner',  // 'inner' | 'outer'
    i18n: {
      fallbackError: '通信に失敗しました。時間をおいて再度お試しください。',
      retry: '再読み込み'
    },
    urlBuilder: null, // A型：function(el){ return '...'; }
    debug: true, // ★開発中は true にすると生レスポンスをそのまま出す
  };
  (function () {
    try {
      var root = (window.SignmallAjaxEnv && window.SignmallAjaxEnv.ajaxRemodal) || {};
      if (root && typeof jQuery !== 'undefined') {
        DEFAULTS = jQuery.extend(true, {}, DEFAULTS, root);
      }
    } catch (e) { }
  })();

  //=============================================================
  // 環境既定の取得（内部<ENV<options の順にマージ）
  //=============================================================
  function readEnv() {
    var root = global.SignmallAjaxEnv && global.SignmallAjaxEnv.ajaxRemodal;
    return root ? root : {};
  }

  //=============================================================
  // modalId単位の状態管理
  //=============================================================
  var state = {
    // modalId: {
    //   loading: false,
    //   ac: AbortController,
    //   reqId: number,
    //   prevHtml: string,
    //   lastRequest: { url: string },
    // }
  };

  // メモリキャッシュ（任意）
  var memoryCache = new Map(); // key=url, val={html,ts,status}

  //=============================================================
  // ユーティリティ
  //=============================================================
  function ns(modalId, ev) {
    return ev + '.' + modalId + DEFAULTS.eventNamespace;
  }

  function ensureTarget(modalId) {
    var $modal = $('[data-remodal-id="' + modalId + '"]');
    if (!$modal.length) return null;
    var $target = $('#' + modalId + '_content');
    if (!$target.length) {
      $target = $('<div/>', { id: modalId + '_content' });
      $modal.append($target);
    }
    return $target;
  }

  function openRemodal(modalId) {
    try {
      $('[data-remodal-id="' + modalId + '"]').remodal().open();
    } catch (e) {
      // Remodal未導入でも落とさない
    }
  }

  function setBusy($el, busy /*, loadingHtml */) {
    if (!$el || !$el.length) return;

    if (busy) {
      // 1) まず真っ白（中身を空に）
      try { $el.empty(); } catch (e) { }

      // 2) 直ちにインライン・スピナーを挿入（オーバーレイは使わない）
      $el.attr('aria-busy', 'true');
      var $sp = $('<div class="ModalAjaxLoader__inlineSpinner Cnt" role="status" aria-live="polite"></div>').append(
        $('<img>', {
          src: '/assets/images/icon/loadingOvalBlue.svg',
          alt: 'loading',
          width: 80, height: 80
        })
      );
      $el.append($sp);
    } else {
      // 完了時はスピナーだけ除去（フェードなし）
      $el.removeAttr('aria-busy');
      $el.find('.ModalAjaxLoader__inlineSpinner').remove();
      // 既存のオーバーレイ要素が残っても念のため除去
      $el.children('.ModalAjaxLoader__overlay').remove();
    }
  }

  function paramsFromMapping(el, mapping) {
    var out = {};
    if (!mapping) return out;
    for (var key in mapping) {
      if (!Object.prototype.hasOwnProperty.call(mapping, key)) continue;
      var dataKey = mapping[key];
      out[key] = $(el).data(dataKey) || '';
    }
    return out;
  }

  function buildUrlByParams(endpoint, params) {
    var usp = new URLSearchParams();
    for (var k in params) {
      if (!Object.prototype.hasOwnProperty.call(params, k)) continue;
      usp.set(k, String(params[k]));
    }
    return endpoint + (endpoint.indexOf('?') >= 0 ? '&' : '?') + usp.toString();
  }

  function finalize(modalId) {
    var s = state[modalId];
    if (!s) return;
    if (s.ac) s.ac = null;
    s.loading = false;
  }

  function rememberPrevHtml($target, modalId) {
    state[modalId] = state[modalId] || {};
    state[modalId].prevHtml = $target.html();
  }

  function restorePrevHtml($target, modalId) {
    var s = state[modalId];
    if (!s) return;
    if (!DEFAULTS.restoreOnError || !s.prevHtml) return;
    $target.html(s.prevHtml);
  }

  function writeFallbackError($target, message, modalId) {
    var $wrap = $(
      '<div class="AjaxRemodalError" role="alert" aria-live="assertive" tabindex="-1">' +
      '<div class="Wrapper">' +
      '<p class="FS95 M10B">' + escapeHtml(message || DEFAULTS.i18n.fallbackError) + '</p>' +
      '<button type="button" class="Btn Btn-Primary" data-ajaxremodal-retry="1">' + escapeHtml(DEFAULTS.i18n.retry) + '</button>' +
      '</div>' +
      '</div>'
    );
    $target.prepend($wrap);
    try { $wrap.focus(); } catch (e) { }
    $wrap.on('click', '[data-ajaxremodal-retry]', function () {
      var s = state[modalId];
      if (!s || !s.lastRequest) return;
      ModalAjaxLoader.__open(modalId, s.lastRequest.url, { force: true });
    });
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  // 返却HTMLから extractSelector（既定：#<modalId>_content）を抽出
  function extractHtml(modalId, rawHtml) {
    var selector = DEFAULTS.extractSelector || ('#' + modalId + '_content');
    var mode = DEFAULTS.extractMode || 'inner';

    var wrap = document.createElement('div');
    wrap.innerHTML = rawHtml;
    var node = wrap.querySelector(selector);
    if (!node) return rawHtml; // 後方互換：見つからなければ全体

    return (mode === 'outer') ? node.outerHTML : node.innerHTML;
  }

  //=============================================================
  // コア：オープン処理（POST対応 + 開発時は生本文/本番は従来フォールバック）
  //=============================================================
  function coreOpen(modalId, url, opts) {
    state[modalId] = state[modalId] || {};
    var s = state[modalId];

    try {
      var _env = (window.SignmallAjaxEnv && window.SignmallAjaxEnv.ajaxRemodal) || {};
      if (_env && typeof jQuery !== 'undefined') {
        DEFAULTS = jQuery.extend(true, {}, DEFAULTS, _env);
      }
    } catch (e) {}

    // 最新リクエストID（戻り順入替え対策）
    s.reqId = (s.reqId || 0) + 1;
    var myReqId = s.reqId;

    // 進行中があれば中断（abort&replace）
    if (s.loading && s.ac) {
      try { s.ac.abort(); } catch (e) { }
    }
    s.ac = new AbortController();
    s.loading = true;
    s.lastRequest = { url: url, method: (opts && opts.method) || 'GET' };

    // Remodalは先に開く（固定）
    openRemodal(modalId);

    var $target = ensureTarget(modalId);
    if (!$target || !$target.length) {
      console.error('ModalAjaxLoader: targetが見つかりません: #' + modalId + '_content');
      s.loading = false;
      return;
    }

    // ローディング（まず白紙→即スピナー：setBusy はインライン表示版を想定）
    rememberPrevHtml($target, modalId);
    setBusy($target, true, DEFAULTS.loadingHtml);

    // メモリキャッシュ（URL単位）
    if (DEFAULTS.cache === 'memory' && memoryCache.has(url)) {
      var cached = memoryCache.get(url);
      if ((state[modalId] || {}).reqId === myReqId) {
        setBusy($target, false);
        var htmlFromCache = extractHtml(modalId, cached.html);
        $target.html(htmlFromCache);
      }
      finalize(modalId);
      return;
    }

    // タイムアウト
    var toId = setTimeout(function () {
      try { s.ac && s.ac.abort(); } catch (e) { }
    }, DEFAULTS.timeout);

    // fetch 初期化（opts の method/body/headers を反映）
    var fetchInit = {
      method: (opts && opts.method) || 'GET',
      headers: $.extend({}, DEFAULTS.headers, (opts && opts.headers) || {}),
      signal: s.ac.signal,
      credentials: DEFAULTS.credentials
    };
    if (fetchInit.method === 'POST') {
      fetchInit.body = (opts && opts.body) || null;
    }

    fetch(url, fetchInit)
      .then(function (res) {
        s._status = res.status;
        s._ctype = (res.headers && res.headers.get && res.headers.get('content-type')) || '';
        return res.text(); // まず text として受け取り、後で JSON を試みる
      })
      .then(function (bodyText) {
        if ((state[modalId] || {}).reqId !== myReqId) return;

        // =========================
        // JSON 判定（強化版・本パッチ）
        // =========================
        var json = (window.ModalAjaxLoader && ModalAjaxLoader.safeParseJson)
          ? ModalAjaxLoader.safeParseJson(bodyText)
          : (function (t){ try { return JSON.parse(t); } catch(e){ return null; } })(bodyText);

        if (json && typeof json.html === 'string') {
          var extracted = extractHtml(modalId, json.html);
          setBusy($target, false);
          $target.html(extracted);

          if (DEFAULTS.cache === 'memory') {
            memoryCache.set(url, { html: json.html, ts: Date.now(), status: json.status || 'ok' });
          }
          return;
        }

        // JSON ではない → 開発(debug)なら本文そのまま表示、本番は従来メッセージ
        setBusy($target, false);
        if (DEFAULTS && DEFAULTS.debug) {
          var safe = escapeHtml(bodyText || '');
          $target.html(
            '<pre style="white-space:pre-wrap;word-break:break-word;max-height:70vh;overflow:auto;margin:0;padding:10px;border:1px solid #ccc;background:#fff;color:#000;">'
            + safe +
            '</pre>'
          );
        } else {
          restorePrevHtml($target, modalId);
          writeFallbackError($target, DEFAULTS.i18n.fallbackError, modalId);
        }
      })
      .catch(function (err) {
        if ((state[modalId] || {}).reqId !== myReqId) return;

        setBusy($target, false);
        if (DEFAULTS && DEFAULTS.debug) {
          var msg = (err && (err.stack || err.message || String(err))) || 'Unknown error';
          var safe = escapeHtml(msg);
          $target.html(
            '<pre style="white-space:pre-wrap;word-break:break-word;max-height:70vh;overflow:auto;margin:0;padding:10px;border:1px solid #ccc;background:#fff;color:#000;">'
            + safe +
            '</pre>'
          );
        } else if (DEFAULTS.restoreOnError) {
          restorePrevHtml($target, modalId);
          writeFallbackError($target, DEFAULTS.i18n.fallbackError, modalId);
        } else {
          $target.prepend('<div class="Cnt P10 FCGray FS90">' + escapeHtml(DEFAULTS.i18n.fallbackError) + '</div>');
        }
        try { console.error('ModalAjaxLoader error:', err && (err.message || err)); } catch (e) { }
      })
      .finally(function () {
        clearTimeout(toId);
        finalize(modalId);
      });
  }



  //=============================================================
  // 公開API
  //=============================================================
  var ModalAjaxLoader = {
    //=============================================================
    //  ModalAjaxLoader の初期化（B型既定／必要時のみA型）
    //  ModalAjaxLoader.init({
    //    modalId: 'modal_Ship',
    //    endpoint: '/api/get-shiptable.html',
    //    paramsMapping: { sku: 'sku', ship_id: 'shipId' }
    //  }, { timeout: 15000 });
    //=============================================================
    init: function (config, options) {
      if (!config || !config.modalId) {
        console.error('ModalAjaxLoader.init: modalId は必須です。');
        return;
      }
      if (!config.endpoint && !(options && typeof options.urlBuilder === 'function')) {
        console.error('ModalAjaxLoader.init: endpoint か urlBuilder のどちらかは必須です。');
        return;
      }

      // デフォルト < ENV < options（深いマージ）
      var env = readEnv();
      DEFAULTS = $.extend(true, {}, DEFAULTS, env, options || {});

      // endpointに "URL [space] selector" のショートハンドが来た場合は分解
      if (config.endpoint && config.endpoint.indexOf(' ') > -1 && !DEFAULTS.extractSelector) {
        var parts = config.endpoint.split(/\s+/, 2);
        config.endpoint = parts[0];
        DEFAULTS.extractSelector = parts[1]; // e.g. '#Index-Ship'
      }

      // 抽出セレクタが未設定なら modalId_content を既定に
      if (!DEFAULTS.extractSelector) {
        DEFAULTS.extractSelector = '#' + config.modalId + '_content';
      }
      if (!DEFAULTS.extractMode) {
        DEFAULTS.extractMode = 'inner';
      }

      var modalId = config.modalId;
      var triggerSelector = '.' + modalId + '_trigger';

      // 委譲クリック（既存をoff → on）
      $(document)
        .off(ns(modalId, 'click'), triggerSelector)
        .on(ns(modalId, 'click'), triggerSelector, function () {
          var el = this;

          // URL生成：A型があれば優先、なければB型
          var url = '';
          if (typeof DEFAULTS.urlBuilder === 'function') {
            try {
              url = DEFAULTS.urlBuilder(el);
            } catch (e1) {
              console.error('urlBuilder で例外:', e1);
              return;
            }
          } else {
            var params = paramsFromMapping(el, config.paramsMapping || {});
            url = buildUrlByParams(config.endpoint, params);
          }

          ModalAjaxLoader.__open(modalId, url);
        });
    },

    //=============================================================
    // 公開API（POST等の送信オプションを受け取れるように拡張）
    //=============================================================
    open: function (modalId, url, opts) {
      if (!modalId || !url) return;
      ModalAjaxLoader.__open(modalId, url, opts || {});
    },

    __open: function (modalId, url, opts) {
      coreOpen(modalId, url, opts || {});
    }

  };

  //=============================================================
  // ★追加：安全JSONパース（BOM / XSSI / 先頭ノイズ / HTML混入 吸収）
  //=============================================================
  ModalAjaxLoader.safeParseJson = function (bodyText) {
    var txt = String(bodyText || '');

    // UTF-8 BOM 除去
    if (txt.charCodeAt(0) === 0xFEFF) txt = txt.slice(1);

    // XSSI 対策（例: ")]}',\n" を先頭に吐くサーバ）
    if (txt.slice(0, 5) === ")]}',") {
      var nl = txt.indexOf('\n');
      txt = (nl >= 0) ? txt.slice(nl + 1) : '';
    }

    // 先頭の制御文字/空白の除去
    txt = txt.replace(/^\uFEFF?[\s\u0000-\u001F]+/, '');

    // 最初の { または [ を起点にスライス（警告やHTML先頭を吸収）
    var i1 = txt.indexOf('{');
    var i2 = txt.indexOf('[');
    var i = (i1 >= 0 && i2 >= 0) ? Math.min(i1, i2) : (i1 >= 0 ? i1 : i2);
    if (i > 0) txt = txt.slice(i);

    try {
      return JSON.parse(txt);
    } catch (e) {
      return null;
    }
  };

  // export
  global.ModalAjaxLoader = ModalAjaxLoader;



})(window, window.jQuery);

// =============================================================
// 1) 固定ID/クラスの既定（すでにDEFAULTSがあればマージ）
// =============================================================
(function (global, $) {
  'use strict';
  if (!global.ModalAjaxLoader) return;

  // 既定（あれば上書きしない）
  var FIXED = {
    modalId: 'ModalAjaxLoader',
    triggerCls: 'ModalAjaxLoader_trigger',
    contentId: 'ModalAjaxLoader_content'
  };

  // ===========================================================
  // 2) Remodal本体が無ければ自動挿入
  // ===========================================================
  function ensureFixedModal() {
    var sel = '[data-remodal-id="' + FIXED.modalId + '"]';
    if ($(sel).length) return;
    var html =
      '<div class="remodal PT-G70 SP-G95 R5 Lft modalArea" data-remodal-id="' + FIXED.modalId + '">' +
      '<button data-remodal-action="close" class="remodal-close" aria-label="閉じる"></button>' +
      '<div id="' + FIXED.contentId + '"></div>' +
      '<div class="WrapperP"><div class="Cnt M20">' +
      '<button data-remodal-action="close" class="BL-S1 BL-CCC R3 P5 P20R P20L Cnt StatW3">閉じる</button>' +
      '</div></div>' +
      '</div>';
    // body直下が安全（既存CSSルールに依存するなら調整）
    $('body').append(html);
  }

  // ===========================================================
  // 3) data-* から endpoint とパラメータを抽出
  //    - data-end_point（推奨: snake_case）/ data-endpoint（後方互換）対応
  //    - その他 data-xxx は全部クエリに載せる（xxx=値）
  // ===========================================================
  function buildFromDataset(el) {
    var $el = $(el);
    // endpoint は end_point 優先、なければ endpoint
    var endpoint = $el.data('end_point') || $el.data('endpoint') || '';
    if (!endpoint) return null;

    // クリック要素の data-* をすべて収集（endpoint系は除外）
    var data = el.dataset || {};
    var params = {};
    Object.keys(data).forEach(function (k) {
      // dataset は camel なので、元の属性と整合させるために蛇腹へ変換
      var snake = k.replace(/[A-Z]/g, function (m) { return '_' + m.toLowerCase(); });
      if (snake === 'end_point' || snake === 'endpoint') return;
      // jQueryの .data() で set されている可能性にも対応
      var val = $el.data(k) != null ? $el.data(k) : data[k];
      if (val != null && val !== '') params[snake] = val;
    });

    // jQuery .data('xxx_yyy') にも対応（datasetに無いケース）
    $.each($el.data(), function (k, v) {
      if (k === 'end_point' || k === 'endpoint') return;
      // すでに params にあればスキップ（dataset優先）
      if (params.hasOwnProperty(k)) return;
      params[k] = v;
    });

    return { endpoint: endpoint, params: params };
  }

  // ===========================================================
  // オートバインド
  //  - クリック要素の data-* と近傍フォーム値から URL/Body を生成
  //  - data-method="POST" があれば POST で送信（x-www-form-urlencoded）
  // ===========================================================
  function autobind() {
    $(document)
      .off('click.modalajaxloader.auto', '.' + FIXED.triggerCls)
      .on('click.modalajaxloader.auto', '.' + FIXED.triggerCls, function () {
        ensureFixedModal();

        var $el = $(this);
        var pack = buildFromDataset(this);
        if (!pack) return;

        // 近傍フォームの値を params に取り込み（data-* が優先）
        var $form = $el.closest('form');
        if ($form.length) {
          var arr = $form.serializeArray();
          arr.forEach(function (kv) {
            if (!kv.name) return;
            if (pack.params.hasOwnProperty(kv.name)) return;
            pack.params[kv.name] = kv.value;
          });
        }

        // 送信メソッド判定（既定 GET / data-method="POST" を尊重）
        var method = String($el.data('method') || 'GET').toUpperCase();
        var url, body = null, headers = null;

        if (method === 'POST') {
          // POST: body を x-www-form-urlencoded で作成
          var usp = new URLSearchParams();
          Object.keys(pack.params || {}).forEach(function (k) {
            if (pack.params[k] != null) usp.set(k, String(pack.params[k]));
          });
          url = pack.endpoint;
          body = usp.toString();
          headers = { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' };
        } else {
          // GET: クエリを URL に連結
          var uspGet = new URLSearchParams();
          Object.keys(pack.params || {}).forEach(function (k) {
            if (pack.params[k] != null) uspGet.set(k, String(pack.params[k]));
          });
          url = pack.endpoint + (pack.endpoint.indexOf('?') >= 0 ? '&' : '?') + uspGet.toString();
        }

        // 実行
        ModalAjaxLoader.open(FIXED.modalId, url, { method: method, body: body, headers: headers });
      });
  }


  // DOMContentLoaded 後に自動有効化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      autobind();
    });
  } else {
    autobind();
  }

})(window, window.jQuery);
